import React from 'react'
import MaterialTable, { Column } from "@material-table/core";
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import { TablePagination } from "@mui/material";

const Table = ({columns, data}) => {
  return (
    <div>
        <MaterialTable 
            style={{ 
                backgroundColor: "#dcedc8",                                                                                          
            }}                     
            columns={columns}
            data={data}
            title=""
            options={{
                headerStyle: { 
                    fontWeight: "bold", 
                    whiteSpace: 'nowrap',  
                    backgroundColor:"#dcedc8",
                    color:"black",
                    border:"none"               
                },                                                                             
                pageSizeOptions: [5, 10, 20, 50, 100],
                pageSize:5,                
                cellStyle: { 
                    // whiteSpace: 'nowrap', 
                    //  backgroundColor:"#f4faed",
                    border:"none"                
                },   
                rowStyle: (rowData, index) => ({
                    backgroundColor:'#f4faed' ,                     
                }),                               
                exportAllData: true,
                exportMenu: [
                    {
                        label: "Export CSV",
                        exportFunc: (cols, datas) =>
                        ExportCsv(cols, datas, "Group List"),
                    },
                ],
                // filtering: true,
            }}
            components={{
                Pagination: props => (
                <TablePagination
                    {...props}
                    labelRowsPerPage={<div className="mt-3">Rows per page:</div>}
                />
                ),                    
            }}
        />
    </div>  
  )
}

export default Table
